import { RSVPModal } from "@/components/RSVPModal";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/events/$eventId/rsvp",
)({
  component: function RouteComponent() {
    const { eventId } = Route.useParams();
    const navigate = useNavigate();

    const handleClose = () => {
      navigate({ to: "/" });
    };

    return <RSVPModal eventId={eventId} isOpen={true} onClose={handleClose} />;
  },
});
